import React from 'react';
import { PropTypes } from 'prop-types';
import { RxCross2 } from 'react-icons/rx';
import Icon from '@mdi/react';
import CardUL from '../UL/CardUL';
import { getIcon } from '../../utils/api/site';
import {
  calculateAndFormatSites,
  calculateAndFormatDistance,
  calculateAndFormatTime,
} from '../../utils/routeDetails';
import { formatNumericDate, getTimeInHoursAndMins } from '../../utils/dates';
import tailwindTheme from '../../../../../config/tailwind.config';

const RouteDetails = ({
  routeDate, sitesArray, handleSiteClick = () => { }, handleRemoveStop = () => { }, onDragEnd = () => { }, totalDistance = 0, totalTime = 0, isDragDisabled = false,
}) => {
  const renderRouteInfo = (site, index) => {
    if (index === 0) {
      return <div className="startingPoint">Start</div>;
    }
    if (Number(site?.distance)) {
      return (
        <div className="siteData">
          <div className="siteDistance whitespace-nowrap">{site.distance}mi</div>
          <div className="siteTime whitespace-nowrap">
            {getTimeInHoursAndMins(site.time)}
          </div>
        </div>
      );
    }
    return <div className="w-15">Distance unknown</div>;
  };

  const routeInnerCardContent = (site, index) => {
    return (
      <>
        <div className="firstOuterDiv flex items-center gap-3">
          <div className="firstInnerDiv flex items-center justify-center w-5 h-5 rounded-full bg-vamos-green2 text-vamos-black font-normal text-xs">
            {index + 1}
          </div>

          <div className="secondInnerDiv flex items-center gap-3">
            {site?.icon && (
              <div className="siteIcon flex items-center">
                <Icon
                  className="ml-3"
                  path={getIcon(site.icon)}
                  size={1.2}
                />
              </div>
            )}

            <button
              type="button"
              className="min-w-[35%] font-normal underline text-lg text-left"
              key={site.id}
              onClick={() => handleSiteClick(site)}
            >
              {site.site_name}
            </button>
          </div>
        </div>

        <div className="secondOuterDiv flex items-center gap-3 text-sm text-right">
          {renderRouteInfo(site, index)}
          <button
            type="button"
            className="stopRemove"
            onClick={() => handleRemoveStop(site)}
          >
            <RxCross2 />
          </button>
        </div>
      </>
    );
  };

  return (
    <div>
      <div
        className="flex border rounded-md overflow-hidden h-16 items-center text-base font-bold mb-1 px-6 gap-1 min-w-107"
        style={{
          borderColor: sitesArray?.length > 0 ? tailwindTheme.theme.extend.colors['vamos-black'] : tailwindTheme.theme.extend.colors['vamos-blue-gray'],
          color: sitesArray?.length > 0 ? tailwindTheme.theme.extend.colors['vamos-black'] : tailwindTheme.theme.extend.colors['vamos-blue-gray'],
        }}
      >
        <div className="flex-1 whitespace-nowrap">{formatNumericDate(routeDate) || 'N/A'}</div>
        <div className="flex-1 whitespace-nowrap">
          {calculateAndFormatSites(sitesArray)}
        </div>
        <div className="flex-1 whitespace-nowrap">
          {calculateAndFormatDistance(sitesArray, totalDistance)}
        </div>
        {totalTime && (
          <div className="flex-1  whitespace-nowrap">
            {calculateAndFormatTime(sitesArray, totalTime)}
          </div>
        )}
      </div>
      <CardUL
        data={sitesArray}
        innerCardContent={routeInnerCardContent}
        isDraggable={sitesArray?.length > 1}
        isDragDisabled={isDragDisabled}
        onDragEnd={onDragEnd}
      />
    </div>
  );
};

export default RouteDetails;

RouteDetails.propTypes = {
  routeDate: PropTypes.string.isRequired,
  sitesArray: PropTypes.array.isRequired,
  handleSiteClick: PropTypes.func,
  handleRemoveStop: PropTypes.func,
  onDragEnd: PropTypes.func,
  totalDistance: PropTypes.number,
  totalTime: PropTypes.number,
  isDragDisabled: PropTypes.bool,
};
